import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ClienteRoutingModule } from './cliente-routing.module';
import { ListaComponent } from './pages/lista/lista.component';
import { DetalhesComponent } from './pages/detalhes/detalhes.component';
import {ComponentesModule} from "../../../core/componentes/componentes.module";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {NgSelectModule} from "@ng-select/ng-select";
import {NovoClienteComponent} from './pages/novo-cliente/novo-cliente.component';
import {NgxMaskDirective} from "ngx-mask";
import {NgxPaginationModule} from "ngx-pagination";
import {DocumentoFormatPipe} from "../../../shared/pipes/documento-format.pipe";
import {TelefoneFormatPipe} from "../../../shared/pipes/telefone-format.pipe";


@NgModule({
  declarations: [
    ListaComponent,
    DetalhesComponent,
    NovoClienteComponent
  ],
  imports: [
    CommonModule,
    ClienteRoutingModule,
    ComponentesModule,
    ReactiveFormsModule,
    NgSelectModule,
    NgxMaskDirective,
    NgxPaginationModule,
    FormsModule,
    DocumentoFormatPipe,
    TelefoneFormatPipe
  ],
  exports: [
    NovoClienteComponent
  ]
})
export class ClienteModule { }
